import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const ProductsContext = createContext(null);

const fetchProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const ProductsProvider = ({ children }) => {
  const query = useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
    staleTime: 5 * 60_000,
  });

  const products = query.data || [];
  const findBySlug = (slug) => products.find((p) => p.slug === slug);

  return (
    <ProductsContext.Provider
      value={{ products, isLoading: query.isLoading, isError: query.isError, findBySlug }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => useContext(ProductsContext);
